async function copyTableWithFormat(param = { data: [], type: 'normal', base: true }) {
  let { data, type, base } = param
  let _datas = undefined
  switch (type) {
    case 'normal': {
      _datas = processNormalTable(data)
    } break;
    case 'primary_div': {
      _datas = processPrimaryDivTable(data)
    } break;
    case 'indicator': {
      _datas = processIndicatorTable(data)
    } break;
    default: {
      _datas = processNormalTable(data)
    }
  }
  //根据base的值，选择性切换是否需要正则除去所有周期表头数据内的（%）
  // setBaseShow(data, base)
  //生成表格格式
  _datas = _datas.map(item => {
    return item.join('\t')
  })
  _datas = _datas.join('\n')


  let cpData = _datas
  let res = await this.$copyText(cpData)
  if (res && res.action === "copy") {
    return true
  } else {
    return false
  }
}

function processNormalTable(data) {
  let offsetArr = data.labels.map(item => {
    return item.label
  })
  let rowHead = []
  rowHead = [].concat(["片名", "人群"]).concat(offsetArr)
  let rows = []
  rows = data.datasets.map((item, row_index) => {
    let head = [item.label]
    let formatItem = item.data.map(item => {
      return item ? item + "%" : "--"
    })
    return head.concat(data.tableConfig.crowd[row_index]).concat(formatItem)
  })
  return [rowHead].concat(rows)
}

function processPrimaryDivTable(data) {
  let rowHead = []
  rowHead = [].concat(["片名", "人群"]).concat(data.offset.name)
  let rows = []
  rows = data.results.map(item => {
    return [item.title, data.crowd + '(' + item.base + ')', ((item.count / item.base) * 100).toFixed(1) + '%']
  })
  return [rowHead].concat(rows)
}
function processIndicatorTable(data) {
  let rowHead = []
  rowHead = [].concat(["类型", "人群"]).concat(data.offset.name)
  let rows = []
  rows = data.results.map(item => {
    return [item.category, data.crowd + '(' + item.base + ')', ((item.count / item.base) * 100).toFixed(1) + '%']
  })
  return [rowHead].concat(rows)
}
function setBaseShow() {
  return
}
export default copyTableWithFormat